import { memo } from 'react'
import cn from 'classnames'

import { ZODIAC_PATHS } from './icons'
import type { ZodiacIconProps } from './types'

import styles from './ZodiacIcon.module.scss'

/** Контурный знак зодиака, 24px по спеке, без плашек и подложек. */
export const ZodiacIcon = memo(function ZodiacIcon(props: ZodiacIconProps) {
  const { name, size = 24, isSelected = false } = props

  return (
    <svg
      className={cn(styles.root, isSelected && styles.isSelected)}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
    >
      <path d={ZODIAC_PATHS[name]} />
    </svg>
  )
})
